import React, { useEffect, useMemo, useState } from 'react';
import ParecerCompleto from './ParecerCompleto';
import OcTrilhaAgencias from './OcTrilhaAgencias';

// RiskMind OC - Painel completo por empresa x periodo (padrao relatorio ItauBBA).
const C = {
  navy: '#0A1628', blue: '#1A3F6F', amber: '#C87B2A', gold: '#E8C56D', cream: '#FAF7F2',
  red: '#DC2626', green: '#15803D', amber2: '#D97706', muted: '#6b7280', line: '#e5e7eb',
  ink: '#0f172a', paper: '#ffffff',
};
const fm = (v) => v == null ? 'n/d' : (Math.abs(v) >= 1e9 ? 'R$ ' + (v / 1e9).toFixed(2).replace('.', ',') + ' bi' : 'R$ ' + (v / 1e6).toFixed(1).replace('.', ',') + ' M');
const pc = (v) => v == null ? 'n/d' : (100 * v).toFixed(1).replace('.', ',') + '%';
const pd1 = (v) => v == null ? 'n/d' : (+v).toFixed(2).replace('.', ',') + '%';
const nx = (v, d = 2) => v == null ? 'n/d' : (+v).toFixed(d).replace('.', ',');
const dt = (d) => d ? String(d).slice(0, 10) : '';
const qlabel = (d) => { if (!d) return ''; const m = +String(d).slice(5, 7); const q = m <= 3 ? 1 : m <= 6 ? 2 : m <= 9 ? 3 : 4; return q + 'T' + String(d).slice(2, 4); };
const zColor = (z) => /Perigo|Insolvente/i.test(z || '') ? C.red : /Cinza|Penumbra/i.test(z || '') ? C.amber2 : /Segura|Solvente/i.test(z || '') ? C.green : C.muted;

const box = { background: C.paper, border: '1px solid ' + C.line, borderRadius: 10, padding: '14px 16px' };
const lbl = { fontSize: 10.5, letterSpacing: 0.8, color: C.muted, textTransform: 'uppercase', marginBottom: 4 };
const H = ({ children }) => (<div style={{ fontSize: 13, fontWeight: 700, color: C.navy, borderBottom: '2px solid ' + C.navy, padding: '0 0 6px', margin: '22px 0 10px' }}>{children}</div>);
const Chip = ({ text, color }) => (<span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 999, fontSize: 11.5, fontWeight: 700, color: '#fff', background: color }}>{text}</span>);
const Card = ({ t, v, s, color }) => (
  <div style={{ ...box, flex: 1, minWidth: 150 }}>
    <div style={lbl}>{t}</div>
    <div style={{ fontSize: 20, fontWeight: 800, color: color || C.ink }}>{v}</div>
    {s ? <div style={{ fontSize: 11.5, color: C.muted, marginTop: 2 }}>{s}</div> : null}
  </div>
);
const KV = ({ k, v, color }) => (
  <div style={{ minWidth: 130, flex: 1 }}>
    <div style={lbl}>{k}</div>
    <div style={{ fontSize: 15, fontWeight: 700, color: color || C.ink }}>{v}</div>
  </div>
);

export default function OcPainel({ api, cnpj }) {
const [verParecer, setVerParecer] = useState(false);
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [sel, setSel] = useState(null);
  const [trk, setTrk] = useState(null);
  useEffect(() => {
    let on = true;
    setData(null); setErr(null); setSel(null);
    api('/api/oc/painel/' + encodeURIComponent(cnpj))
      .then((d) => { if (on) { setData(d); setSel(d && d.latest ? d.latest.data_base : null); } })
      .catch((e) => { if (on) setErr(e); });
    return () => { on = false; };
  }, [api, cnpj]);
  useEffect(() => {
    let on = true;
    Promise.all([
      api('/api/oc/rating-track/' + encodeURIComponent(cnpj)).catch(() => null),
      api('/api/oc/drift/' + encodeURIComponent(cnpj)).catch(() => null),
    ]).then(([t, d]) => { if (on) setTrk({ t: t, d: d }); });
    return () => { on = false; };
  }, [api, cnpj]);
  const per = useMemo(() => {
    if (!data || !data.periodos) return null;
    return data.periodos.find((r) => r.data_base === sel) || data.latest;
  }, [data, sel]);
  if (err) return <div style={{ ...box, marginTop: 18, color: C.muted }}>Painel completo indisponivel ({err.status || 'erro'}).</div>;
  if (!data) return <div style={{ ...box, marginTop: 18, color: C.muted }}>carregando painel completo...</div>;
  if (!per) return null;
  const p = per.payload || {};
  const ind = p.indicadores || {}; const alt = ind.altman || {}; const kz = ind.kanitz || {}; const mk = ind.merton || {};
  const st = p.setorial || {}; const fin = p.financeiro || {}; const lim = p.limite || {};
  const bh = p.behavioral; const mr = p.mia_risk; const ag = p.agencia; const pts = p.pontos || {}; const par = p.parecer_cfo || {}; const dr = p.drift || {};
  // CONTRATO COM O MOTOR — services/engine/models/merton.js devolve `PD` (maiuscula,
  // ja em PERCENTUAL nos dois caminhos: o observado multiplica por 100 na saida e o
  // proxy ja calcula em escala 0-99) e `pd_source` ("merton_observed" | "merton_proxy").
  // Ate 07/08/2026 este painel lia `pd`/`pd_proxy` e `source`/`observado` — nomes que o
  // motor nunca emitiu. Resultado: o cartao dizia "n/d" e "proxy" para 100% das empresas,
  // abertas e fechadas, mesmo quando o Merton observado tinha sido calculado e entrado
  // na PD final com peso 0,20. Os nomes antigos ficam como fallback, sem custo.
  const mkPd = mk && (mk.PD != null ? mk.PD : (mk.pd != null ? mk.pd : mk.pd_proxy));
  const mkObs = mk && (mk.pd_source === 'merton_observed' || mk.source === 'observado' || mk.observado === true);
  return (
    <div style={{ marginTop: 18 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>Analise individual - padrao relatorio</div>
        <span style={{ marginLeft: 'auto', fontSize: 11.5, color: C.muted }}>periodo</span>
        <select value={sel || ''} onChange={(e) => setSel(e.target.value)} style={{ padding: '4px 8px', border: '1px solid ' + C.line, borderRadius: 8, fontSize: 12.5, color: C.navy }}>
          {data.periodos.map((r) => (<option key={r.data_base} value={r.data_base}>{qlabel(r.data_base)} - {dt(r.data_base)}</option>))}
        </select>
      </div>
      <H>Indicadores da analise - LTM {qlabel(per.data_base)} ({dt(per.data_base)})</H>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Card t={'Altman Z"'} v={alt.zona || 'n/d'} s={alt.z != null ? 'Z ' + nx(alt.z) : null} color={zColor(alt.zona)} />
        <Card t="Termometro de Kanitz" v={kz.zona || 'n/d'} s={(kz.k != null ? 'K ' + nx(kz.k, 1) : '') + (kz.pl_negativo ? ' - PL negativo' : '')} color={zColor(kz.zona)} />
        <Card t={'Merton KMV - ' + (mkObs ? 'observado' : 'proxy')} v={mkPd != null ? pd1(mkPd) : 'n/d'} s={mkObs ? 'PD implicita de mercado' : 'sinal de mercado nao disponivel'} color={mkObs ? C.green : C.muted} />
        <Card t={'PD Final - ' + (ind.rating || '')} v={pd1(ind.pd_final)} s="probabilidade de default" color={C.amber} />
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 10 }}>
        <Card t="Limite tecnico" v={fm(lim.final != null ? lim.final : lim.sugerido)} s="base LTM" />
        <Card t="Posicao setorial" v={st.percentil != null ? 'P' + st.percentil : 'n/d'} s={(st.pares || '?') + ' pares - mediana ' + pd1(st.mediana_pd)} color={st.percentil >= 75 ? C.red : st.percentil <= 25 ? C.green : C.ink} />
        <Card t="Score" v={ind.score != null ? nx(ind.score, 0) : 'n/d'} />
        <Card t="Drift comportamental" v={dr.status || 'sem serie'} s={dr.dr != null ? 'DR ' + nx(dr.dr) : null} color={C.muted} />
      </div>
      <H>Posicao financeira - LTM {qlabel(per.data_base)}</H>
      <div style={{ ...box, display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <KV k="Patrimonio liquido" v={fm(fin.pl)} color={fin.pl < 0 ? C.red : C.ink} />
        <KV k="Ativo total" v={fm(fin.ativo)} />
        <KV k="PL / ativo" v={pc(fin.pl_ativo)} color={fin.pl_ativo < 0 ? C.red : C.ink} />
        <KV k="Liquidez corrente" v={nx(fin.liquidez) + 'x'} color={fin.liquidez != null && fin.liquidez < 1 ? C.red : C.ink} />
        <KV k="Cobertura de juros" v={nx(fin.cobertura) + 'x'} color={fin.cobertura != null && fin.cobertura < 1 ? C.red : C.ink} />
        <KV k="Margem EBIT" v={pc(fin.margem_ebit)} color={fin.margem_ebit < 0 ? C.red : C.ink} />
        <KV k="Receita LTM" v={fm(fin.receita)} />
        <KV k="Lucro liquido LTM" v={fm(fin.lucro)} color={fin.lucro < 0 ? C.red : C.ink} />
      </div>
      {mr ? (<div>
        <H>Avaliacao qualitativa de credito <span style={{ fontWeight: 400, color: C.muted }}>- Mia Risk - advisory, nao altera a decisao</span></H>
        <div style={{ ...box, borderLeft: '4px solid ' + C.blue }}>
          <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 8 }}>
            <KV k="PD do motor (ancora)" v={pd1(ind.pd_final)} />
            <KV k="Direcao" v={(mr.direcao || 'n/d') + (mr.magnitude && mr.magnitude.notches ? ' (' + mr.magnitude.notches + ' notches)' : '')} color={/^favor/i.test(mr.direcao || '') ? C.green : C.ink} />
            {mr.magnitude && mr.magnitude.pd_mult != null ? <KV k="PD apos avaliacao (advisory)" v={pd1(ind.pd_final * mr.magnitude.pd_mult)} color={/^favor/i.test(mr.direcao || "") ? C.green : C.amber2} /> : null}
            <KV k="Confianca" v={mr.confidence != null ? nx(mr.confidence) : 'n/d'} />
          </div>
          <div style={{ fontSize: 12.5, color: C.ink, lineHeight: 1.55 }}><b>Fator dominante:</b> {mr.fator}</div>
        </div>
      </div>) : null}
      <H>Parecer financeiro <span style={{ fontWeight: 400, color: C.muted }}>- {par.fonte === 'mia_cfo' ? 'gerado por Mia CFO' : 'gerado por Mia CFO - sintese quantitativa'}</span></H>
      <div style={{ ...box, fontSize: 12.5, lineHeight: 1.6, color: C.ink }}>
        {par.evolucao ? <p style={{ margin: '0 0 8px' }}><b>Evolucao.</b> {par.evolucao}</p> : null}
        {par.estrutura ? <p style={{ margin: '0 0 8px' }}><b>Estrutura de capital.</b> {par.estrutura}</p> : null}
        {par.liquidez ? <p style={{ margin: 0 }}><b>Liquidez.</b> {par.liquidez}</p> : null}
          {/* O CARD MOSTRA O QUE CABE; O RESTO ABRE AQUI.
              Nao e so questao de texto cortado: `setorial` e `leitura_risco`
              eram gravados pela Mia CFO e NUNCA apareciam nesta tela — o card
              renderizava tres dos cinco blocos. O botao e o que traz os dois
              que faltavam, e tambem o que resolve o texto que nao cabe. */}
          {(par.setorial || par.leitura_risco
            || ((pts.sustentacao || []).length + (pts.atencao || []).length) > 0) ? (
            <div style={{
              marginTop: 12, paddingTop: 10, borderTop: '1px solid ' + C.line,
              display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
            }}>
              <button
                type="button"
                onClick={() => setVerParecer(true)}
                style={{
                  border: '1px solid ' + C.navy, background: C.navy, color: '#fff',
                  borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 700,
                  cursor: 'pointer',
                }}
              >Ver mais</button>
              <span style={{ fontSize: 11.5, color: C.muted }}>
                {[
                  par.setorial ? 'posicao setorial' : null,
                  par.leitura_risco ? 'leitura de risco' : null,
                  'pontos de sustentacao e atencao',
                ].filter(Boolean).join(' · ')}
              </span>
            </div>
          ) : null}
          {verParecer ? (
            <ParecerCompleto
              par={par}
              pontos={pts}
              miaRisk={mr}
              denom={p.denom || null}
              dataBase={par.data_base || null}
              C={C}
              onFechar={() => setVerParecer(false)}
            />
          ) : null}
      </div>
      {bh ? (<div>
        <H>Camada comportamental - registro publico</H>
        <div style={{ ...box, display: 'flex', gap: 14, flexWrap: 'wrap', alignItems: 'center', borderLeft: '4px solid ' + (bh.leitura === 'agrava' ? C.red : C.green) }}>
          <KV k="Cadastral" v={bh.cadastral || 'n/d'} />
          <KV k="CEIS" v={bh.ceis != null ? bh.ceis : 'n/d'} color={bh.ceis > 0 ? C.red : C.ink} />
          <KV k="CNEP" v={bh.cnep != null ? bh.cnep : 'n/d'} color={bh.cnep > 0 ? C.red : C.ink} />
          <div><Chip text={'leitura: ' + (bh.leitura || 'n/d')} color={bh.leitura === 'agrava' ? C.red : C.green} /></div>
          <div style={{ fontSize: 11, color: C.muted, width: '100%' }}>validado por CNPJ - {bh.fonte} - as-of {dt(bh.asof)}</div>
        </div>
      </div>) : null}
      {ag && ag.itens && ag.itens.length ? (<div>
        <H>Ratings de agencia comparaveis</H>
        <div style={{ ...box, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {ag.itens.map((a, i) => (
            <div key={i} style={{ border: '1px solid ' + C.line, borderRadius: 8, padding: '8px 12px' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.navy }}>{a.ag} <span style={{ color: C.amber }}>{a.rating}</span></div>
              <div style={{ fontSize: 10.5, color: C.muted }}>escala {a.escala}{a.data ? ' - ' + a.data : ''}</div>
            </div>
          ))}
          <div style={{ fontSize: 11, color: C.muted, width: '100%' }}>{ag.fonte}</div>
        </div>
      </div>) : null}
      <div style={{ display: 'flex', gap: 10, marginTop: 22, flexWrap: 'wrap' }}>
        <div style={{ ...box, flex: 1, minWidth: 240, borderTop: '3px solid ' + C.green }}>
          <div style={{ ...lbl, color: C.green }}>Pontos de sustentacao</div>
          {(pts.sustentacao || []).map((t, i) => (<div key={i} style={{ fontSize: 12.5, padding: '3px 0', color: C.ink }}>- {t}</div>))}
          {!(pts.sustentacao || []).length ? <div style={{ fontSize: 12, color: C.muted }}>nenhum destaque</div> : null}
        </div>
        <div style={{ ...box, flex: 1, minWidth: 240, borderTop: '3px solid ' + C.red }}>
          <div style={{ ...lbl, color: C.red }}>Pontos de atencao</div>
          {(pts.atencao || []).map((t, i) => (<div key={i} style={{ fontSize: 12.5, padding: '3px 0', color: C.ink }}>- {t}</div>))}
          {!(pts.atencao || []).length ? <div style={{ fontSize: 12, color: C.muted }}>nenhum alerta</div> : null}
        </div>
      </div>
      {trk && trk.t ? (<OcTrilhaAgencias track={trk.t.track} vereditos={trk.t.vereditos} />) : null}
      <div style={{ fontSize: 10.5, color: C.muted, marginTop: 14 }}>
        engine {per.engine_version || 'n/d'} - snapshot {String(per.snapshot_hash || '').slice(0, 12)} - registro imutavel por periodo (point-in-time) - opiniao metodologica de apoio a decisao, nao constitui recomendacao de credito ou investimento.
      </div>
    </div>
  );
}
